var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLab(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 35,
    viewBox: "0 0 29 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7498 1.5V11.1C17.7496 11.6368 17.8865 12.165 18.1479 12.636L27.1011 28.764C27.372 29.2514 27.5093 29.7998 27.4995 30.3552C27.4898 30.9107 27.3333 31.4541 27.0456 31.932C26.7578 32.4099 26.3487 32.8058 25.8584 33.0807C25.3682 33.3556 24.8136 33.5001 24.2494 33.5H4.75056C4.18636 33.5001 3.63184 33.3556 3.14157 33.0807C2.65129 32.8058 2.24216 32.4099 1.95441 31.932C1.66666 31.4541 1.51023 30.9107 1.50048 30.3552C1.49074 29.7998 1.62804 29.2514 1.89885 28.764L10.8521 12.636C11.1135 12.165 11.2504 11.6368 11.2502 11.1V1.5M5.48665 22.3H23.5134M8.81283 1.5H20.1872",
    stroke: "#F2E8D9",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLab);
export default __webpack_public_path__ + "static/media/lab.8b9fd2470b0e61acb8354f531f94bd14.svg";
export { ForwardRef as ReactComponent };